export function getReferenceRoomUrl(): string {
  const newReferenceRoomUrl = `${window.CODMON_MANIFEST.urls.REFERENCE_ROOM_URL}/handouts`;
  return newReferenceRoomUrl;
}
